import { em } from 'polished';
import styled, { css } from 'styled-components';
import ErrorPageBg from '~/assets/images/ErrorPageBg.jpg';

const device = {
  mobile: '@media(max-width: 420px)',
};

export const ErrorPageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  & > * {
    z-index: 2;
  }
  &:before {
    display: block;
    content: '';
    background: url(${ErrorPageBg}) no-repeat top center;
    background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.25;
    z-index: 1;
  }
`;

export const Beat = styled.img`
  ${({ reverse }) => css`
    width: 100%;
    transform: ${reverse && 'rotate(180deg)'};
  `}
`;

export const Content = styled.div`
  text-align: center;
`;

export const Logo = styled.img`
  margin-bottom: ${em('62px')};
  ${device.mobile} {
    width: ${em('240px')};
  }
`;

export const ErrorCode = styled.div`
  margin-bottom: ${em('32px')};
  img {
    position: relative;
    width: ${em('81px')};
    bottom: ${em('32px')};
  }
  span {
    font-size: ${em('96px')};
  }
  ${device.mobile} {
    img {
      width: ${em('60px')};
      bottom: ${em('22px')};
    }
    span {
      font-size: ${em('72px')};
    }
  }
`;

export const Title = styled.h1`
  font-size: ${em('30px')};
  margin-bottom: ${em('8px')};
  font-weight: bold;
  line-height: 1.35;
  text-transform: uppercase;
  ${device.mobile} {
    font-size: ${em('24px')};
  }
`;

export const Description = styled.div`
  line-height: 1.45;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Button = styled.button`
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 290993px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0;
  -webkit-transition: background-color 0.3s ease, opacity 0.3s ease;
  transition: background-color 0.3s ease, opacity 0.3s ease;
  height: 2.0625em;
  line-height: 2.0625em;
  padding: 0 0.9375em;
  font-size: 1em;
  cursor: pointer;
  opacity: 1;
  background-color: #0077c8;
  color: #ffffff;
`;
